module.exports = __webpack_public_path__ + "img/koala.bb84599.png";